import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Cursor() {
  const [label, setLabel] = useState("");
  const [enabled, setEnabled] = useState(false);
  const x = useMotionValue(-200);
  const y = useMotionValue(-200);
  const sx = useSpring(x, { stiffness: 500, damping: 45, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 500, damping: 45, mass: 0.4 });

  useEffect(() => {
    if (window.matchMedia("(hover: none)").matches) return;
    setEnabled(true);
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => {
      const t = e.target.closest("[data-cursor]");
      setLabel(t ? t.getAttribute("data-cursor") : "");
    };
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <motion.div
      style={{ x: sx, y: sy }}
      className="pointer-events-none fixed left-0 top-0 z-[100]"
      aria-hidden="true"
    >
      <div
        className={`-translate-x-1/2 -translate-y-1/2 flex items-center justify-center rounded-full transition-[width,height,background-color,border-color] duration-300 ${
          label
            ? "w-24 h-24 bg-ivory/95 border border-transparent"
            : "w-9 h-9 border border-ivory/40"
        }`}
      >
        {label && (
          <span className="text-[9px] tracking-[0.25em] text-ink font-semibold uppercase text-center leading-tight px-1">
            {label}
          </span>
        )}
      </div>
    </motion.div>
  );
}
